export type Orgs = {
  label: string
  value: string
}

export const orgs: Orgs[] = [
  { label: 'SSP - Secretaria de Segurança Pública', value: 'SSP' },
  { label: 'DETRAN - Departamento Estadual de Trânsito', value: 'DETRAN' },
  { label: 'PM - Polícia Militar', value: 'PM' },
  { label: 'PC - Polícia Civil', value: 'PC' },
  { label: 'CNT - Carteira Nacional de Habilitação', value: 'CNT' },
  { label: 'DIC - Diretoria de Identificação Civil', value: 'DIC' },
  { label: 'CTPS - Carteira de Trabalho e Previdência Social', value: 'CTPS' },
  { label: 'FGTS - Fundo de Garantia do Tempo de Serviço', value: 'FGTS' },
  { label: 'IFP - Instituto Félix Pacheco', value: 'IFP' },
  { label: 'IML - Instituto Médico Legal', value: 'IML' },
  { label: 'MTE - Ministério do Trabalho e Emprego', value: 'MTE' },
  { label: 'OAB - Ordem dos Advogados do Brasil', value: 'OAB' },
  { label: 'SES - Secretaria Estadual de Segurança', value: 'SES' },
  { label: 'SJS - Secretaria da Justiça e Segurança', value: 'SJS' },
]
